import React from 'react';
import './BbRounds.css';

class Rounds extends React.Component
{
  componentDidMount()
  {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  shouldComponentUpdate(nextProps)
  {
    if (nextProps.rounds !== this.props.rounds)
    {
      return true;
    }
    return false;
  }

  render()
  {
    const rounds = this.props.rounds !== undefined ? this.props.rounds : [];
    const roundsPlayed = parseInt(rounds.rounds_played, 10);
    const maxRounds = parseInt(rounds.max_rounds, 10);
    const webMsg = rounds.msg;
    const htm = [];
    let i = parseInt(0, 10);
    let istr;
    for (let index = 0; index < maxRounds; index += 1) {
      i += 1;
      istr = i.toString();
      if (i < 10) {
        istr = `0${istr}`;
      }
      if (i <= roundsPlayed) {
        htm.push(<span className="roundcount">{istr}</span>);
      } else {
        htm.push(<span className="maxrounds">{istr}</span>);
      }
    }

    return (
      <div>
        <div className="row gx-0">
          <div className="col-12" style={{ width: '100%' }}>
            <span className="roundsplayed">ROUNDS: </span>
            {htm}
            <span className="webmsg">{webMsg}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Rounds;
